__turbopack_context__.v({
  "badge": "SpeciesComparisonTable-module-scss-module__c15Kcq__badge",
  "changed": "SpeciesComparisonTable-module-scss-module__c15Kcq__changed",
  "controls": "SpeciesComparisonTable-module-scss-module__c15Kcq__controls",
  "footer": "SpeciesComparisonTable-module-scss-module__c15Kcq__footer",
  "grade": "SpeciesComparisonTable-module-scss-module__c15Kcq__grade",
  "group": "SpeciesComparisonTable-module-scss-module__c15Kcq__group",
  "legend": "SpeciesComparisonTable-module-scss-module__c15Kcq__legend",
  "note": "SpeciesComparisonTable-module-scss-module__c15Kcq__note",
  "pill": "SpeciesComparisonTable-module-scss-module__c15Kcq__pill",
  "pills": "SpeciesComparisonTable-module-scss-module__c15Kcq__pills",
  "root": "SpeciesComparisonTable-module-scss-module__c15Kcq__root",
  "scroller": "SpeciesComparisonTable-module-scss-module__c15Kcq__scroller",
  "speciesCol": "SpeciesComparisonTable-module-scss-module__c15Kcq__speciesCol",
  "speciesLink": "SpeciesComparisonTable-module-scss-module__c15Kcq__speciesLink",
  "speciesName": "SpeciesComparisonTable-module-scss-module__c15Kcq__speciesName",
  "swatch": "SpeciesComparisonTable-module-scss-module__c15Kcq__swatch",
  "table": "SpeciesComparisonTable-module-scss-module__c15Kcq__table",
  "text": "SpeciesComparisonTable-module-scss-module__c15Kcq__text",
  "thumb": "SpeciesComparisonTable-module-scss-module__c15Kcq__thumb",
  "toggle": "SpeciesComparisonTable-module-scss-module__c15Kcq__toggle",
  "toggleState": "SpeciesComparisonTable-module-scss-module__c15Kcq__toggleState",
  "track": "SpeciesComparisonTable-module-scss-module__c15Kcq__track",
});
